import { useMutation } from 'react-query';
import { enqueueSnackbar } from 'notistack';

import { patchCompleteEncounter } from 'api/vulnerabilities/patchCompleteVul';

export const usePatchCompleteVul = () => {
  return useMutation({
    mutationFn: patchCompleteEncounter,
    onSuccess: () => {
      enqueueSnackbar('Vulnerability completed successfully', { variant: 'success' });
    },
    onError: () => {
      enqueueSnackbar('Failed to complete vulnerability', { variant: 'error' });
    },
  });
};
